import { Button, Modal } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

type UpdateInstantPaymentLimitsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const UpdateInstantPaymentLimitsModal = ({
  isOpen,
  onClose,
  onConfirm,
}: UpdateInstantPaymentLimitsModalProps) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t(
        'generalSettings.instantPaymentLimits.amountLimitSection.updateInstantPaymentLimitsModal.title',
      )}
      subtitle={t(
        'generalSettings.instantPaymentLimits.amountLimitSection.updateInstantPaymentLimitsModal.description',
      )}
      actions={[
        <Button
          variant="secondaryNeutral"
          key="cancel"
          text={t('misc.cancel')}
          onClick={onClose}
        />,
        <Button
          variant="primaryBrand"
          key="confirm"
          text={t('misc.confirm')}
          onClick={onConfirm}
        />,
      ]}
      iconName="lock-close"
      iconVariant="info"
    />
  );
};
